// extracted by mini-css-extract-plugin
export var borderRadius = "_ea-4";
export var large = "_ea-3";
export var logoContainer = "_ea-0";
export var nameLogo = "_ea-2";
export var small = "_ea-1";